import React, { useState } from "react";
import { Row, Col, Button, Drawer, Space } from "antd";
import { MenuOutlined, CloseOutlined } from "@ant-design/icons";
import { Link, useLocation } from "react-router-dom";

const HomeNav = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { pathname } = useLocation();

  const currentPath = pathname;

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const navItems = [
    {
      key: "privacy-policy",
      path: "/privacy-policy",
      label: "Privacy Policy",
      show: currentPath !== "/privacy-policy"
    },
    {
      key: "about-us",
      path: "/about-us",
      label: "About Us",
      show: currentPath !== "/about-us"
    },
    {
      key: "contact-us",
      path: "/contact-us",
      label: "Contact Us",
      show: currentPath !== "/contact-us"
    },
    {
      key: "register",
      path: "/register",
      label: "Register",
      show: true
    }
  ];

  return (
    <div className="homenav">
      <Row>
        <Col flex={1}>
          <Link to="/">
            <img className="navlogo" alt="logo" height="40px" src="/images/logo.png" />
          </Link>
        </Col>

        <Col className="desktop-nav-col">
          {navItems.map(
            (item) =>
              item.show && (
                <Link key={item.key} className="navlink customLink" to={item.path}>
                  {item.label}
                </Link>
              )
          )}
          <Link className="navlink" to="/signin">
            <Button
              style={{
                height: "34px",
                borderRadius: "6px",
                width: "110px"
              }}
              type="primary">
              Sign in
            </Button>
          </Link>
        </Col>

        <Col className="mobile-menu-btn">
          <Button
            type="text"
            icon={<MenuOutlined />}
            onClick={toggleMobileMenu}
            className="hamburger-btn"
          />
        </Col>
      </Row>

      <Drawer
        title={
          <div className="drawer-header">
            <Link to="/" onClick={closeMobileMenu}>
              <img className="navlogo" alt="logo" height="32px" src="/images/logo.png" />
            </Link>
            <Button
              type="text"
              icon={<CloseOutlined />}
              onClick={closeMobileMenu}
              className="close-btn"
            />
          </div>
        }
        placement="right"
        closable={false}
        onClose={closeMobileMenu}
        open={mobileMenuOpen}
        width={280}
        bodyStyle={{ padding: "24px 0" }}
        className="mobile-drawer">
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          {navItems.map(
            (item) =>
              item.show && (
                <Link
                  key={item.key}
                  className="navlink customLink mobile-link"
                  to={item.path}
                  onClick={closeMobileMenu}>
                  {item.label}
                </Link>
              )
          )}
          <div className="mobile-signin-container">
            <Link className="navlink" to="/signin" onClick={closeMobileMenu}>
              <Button className="mobile-signin-btn" type="primary">
                Sign in
              </Button>
            </Link>
          </div>
        </Space>
      </Drawer>
    </div>
  );
};

export default HomeNav;
